import styled from "styled-components"

export function FormatMessageContent({
  children,
}: {
  children: React.ReactNode
}) {
  // When stored in db, some characters are escaped, this function unescapes them
  function unescape(content: string | React.ReactNode) {
    if (typeof content === "string") {
      return content
        .replace(/&gt;/g, ">")
        .replace(/&lt;/g, "<")
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'")
        .replace(/&amp;/g, "&")
    }
    return content
  }

  return <Box>{unescape(children)}</Box>
}

const Box = styled.div`
  white-space: pre-wrap; // keep \n as new lines
  overflow-wrap: anywhere; // avoid overflow on long words/URLs
`
